export default "__VITE_ASSET__b3bc28fa__"